import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCloudbeesComponent } from './simple-icons-cloudbees.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCloudbeesComponent ],
    exports:      [ SimpleIconsCloudbeesComponent ],
    bootstrap:    []
})
export class SimpleIconsCloudbeesModule {}
